export type ReturnToLossPayoutType = "credit" | "diamond";

export interface ReturnToLossAmountSnapshot {
  Amount?: number;
  display_amount?: number;
  is_credit_at_snapshot?: boolean;
  payout_type?: ReturnToLossPayoutType;
}

export function isReturnToLossCredit(
  record: ReturnToLossAmountSnapshot,
  fallbackIsCredit?: boolean
): boolean {
  if (typeof record.is_credit_at_snapshot === "boolean") {
    return record.is_credit_at_snapshot;
  }
  if (record.payout_type) {
    return record.payout_type === "credit";
  }
  return !!fallbackIsCredit;
}

export function getReturnToLossDisplayAmount(
  record: ReturnToLossAmountSnapshot
): number {
  if (typeof record.display_amount === "number") {
    return record.display_amount;
  }
  return record.Amount ?? 0;
}
